import Form from 'shared/migration-components/form';
import useFormInputs from 'shared/migration-components/form/util';
import logo from 'shared/assets/images/logo.png';
import darkLogo from 'shared/assets/images/logo-dark.png';

import {Card, Container, Content} from './styles';
import useResetPasswordRequest from 'modules/auth/hooks/use-reset-password-request';

const ResetPasswordRequest: React.FC = () => {
  const {getInput} = useFormInputs();
  const theme = localStorage.getItem('theme');

  return (
    <Container>
      <Content>
        <Card>
          <img
            src={theme === 'dark' ? darkLogo : logo}
            style={{
              width: 180,
              height: 120,
              alignSelf: 'center',
              marginLeft: -20,
            }}
          />
          <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
            <Form
              inputs={[getInput({name: 'email'})]}
              translationKey="UserProps"
              defaultValues={{type: 'panel'}}
              onSubmit={useResetPasswordRequest}
              buttonProps={{
                title: 'Solicitar',
                widthMode: 'expand',
              }}
            />
          </div>
        </Card>
      </Content>
    </Container>
  );
};

export default ResetPasswordRequest;
